export default __webpack_public_path__ + "static/media/teachers.1eb88356.jpg";